// docs: https://github.com/altostra/type-validations#readme
import { objectOf, anyOf } from "@altostra/type-validations";
import { boolean, string, nullOrUndefined } from "@altostra/type-validations/lib/primitives";

export const isGenerativeAiGptAssistantResult = objectOf({
  response: string,
  error: anyOf(string, nullOrUndefined),
  model: string,
  on_brand_failed_warning: boolean,
});
